// 获取cookie
export const getCookie = function (cookieName) {
	let cookies = document.cookie.split(';');
	cookieName += '=';
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		if (cookie.indexOf(cookieName) === 0) return cookie.substring(cookieName.length, cookie.length);
	}
	return '';
}
// 清除cookie
export const clearCookie = function (name) {
	document.cookie = ' wx=;domain=.tunnelling.cn;path=/;max-age=0';
}
// 设置cookie
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}


// WEBPACK FOOTER //
// ./src/assets/js/GetCookie.js